// De werkruimteweergave (/workspace/:id/…) heeft een eigen kaart; daar wordt de
// globale kaart verborgen. Op het segment en niet op de prefix: het overzicht
// /workspaces begint ook met "/workspace" en houdt de globale kaart.
export const isWorkspaceView = (pathname: string): boolean => /^\/workspace(\/|$)/.test(pathname);
